// extracted by mini-css-extract-plugin
export var callCard = "_nf-0";
export var callMessageButton = "_nf-1";
export var helpIcon = "_nf-3";
export var helpIconContainer = "_nf-4";
export var verticalDivider = "_nf-2";